let state = {
  selectedPlan: '',
  selectedPlanGenerate: '',
};

const mutations = {
  setSelectedPlan(state, plan)  {
    state.selectedPlan = plan;
  },
  setSelectedPlanGenerate(state, planGenerate) {
    state.selectedPlanGenerate = planGenerate;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
